import { getCrudActionCreators, touchEtag } from './crud';
import { getLocalActionCreators, removeItem, ACTION_DELETE_ENTITY } from './local';
import { getConsumerActionCreators, deleteConsumer, ACTION_DELETE_CONSUMER } from './consumers';
import { pushRelateds } from './related';
export { getCrudActionCreators, getLocalActionCreators, getConsumerActionCreators, removeItem, deleteConsumer, pushRelateds, ACTION_DELETE_ENTITY, ACTION_DELETE_CONSUMER, touchEtag };